/* eslint camelcase: 0 */
export var PolicyMutationTypes;
(function (PolicyMutationTypes) {
    PolicyMutationTypes["FETCH_POLICIES"] = "FETCH_POLICIES";
})(PolicyMutationTypes || (PolicyMutationTypes = {}));
